export default __webpack_public_path__ + "static/media/il-borgo-gallery-1-moris-lorenzi.f8ff2ccf.jpg";